<template>
  <div class="price" v-if="record.productDeals?.length">
    <p>
      <span class="normal"
        >{{ record.productDeals[0].currencySymbol
        }}{{ record.productDeals[0].finalPrice.toFixed(2) }}</span
      >
      <span class="deal"
        >{{ record.productDeals[0].currencySymbol
        }}{{ record.productDeals[0].fullPrice.toFixed(2) }}
      </span>
    </p>
    <p class="deal-off">{{ record.productDeals[0].priceOff.toFixed(1) }}% off</p>
  </div>
  <div class="price" v-else>{{record.price||record.listPrice? record.currencySymbol||CURRENCY_DATA_MAPPER[record.currency]:'-' }}{{ record.price||record.listPrice }}</div>
</template>

<script setup>
import { defineProps } from 'vue'
import { CURRENCY_DATA_MAPPER } from '@/contants/common'

const { record } = defineProps(['record'])
</script>

<style lang="less" scoped>
.price {
  font-weight: 500;
  color: var(--dark-1);
  .normal {
    font-weight: 500;
    color: var(--dark-1);
  }
  > p {
    white-space: nowrap;
  }
  .deal {
    // 折扣价
    margin-left: 5px;
    font-weight: normal;
    color: var(--dark-3);
    text-decoration: line-through;
    &-off {
      // 折扣率
      font-size: 12px;
      color: var(--red-text);
    }
  }
}
</style>